import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=3e86b9fa"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e86b9fa')) {
      api.createRecord('3e86b9fa', component.options)
    } else {
      api.reload('3e86b9fa', component.options)
    }
    module.hot.accept("./Reports.vue?vue&type=template&id=3e86b9fa", function () {
      api.rerender('3e86b9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Reports.vue"
export default component.exports